"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = require("react");
const uuid_1 = require("uuid");
const appConstants_1 = require("../../../../../constants/appConstants");
const strings_1 = require("../../../../../constants/strings");
const uiConstants_1 = require("../../../../../constants/uiConstants");
const FormLabel_1 = require("../../../../../material-ui-theme/components/styled/FormLabel");
const codingQuery_1 = require("../../../../../queries/codingQuery");
const zustandStore_1 = require("../../../../../zustandStore");
const simpleButton_1 = __importDefault(require("../../../../atoms/button/simpleButton"));
const drawerAside_1 = __importDefault(require("../../../../organisms/drawerAside"));
const useCodingListState_1 = require("../kooks/useCodingListState");
const CODING_LIST_CREATE_NEW_CUSTOM_LIST_ASIDE_ID = appConstants_1.codingListConstants.codingListCreateNewCustomListAsideId;
const CODING_LIST_CREATE_NEW_CUSTOM_LIST_INPUT = appConstants_1.codingListConstants.codingListCreateNewCustomListInput;
const CODING_LIST_CREATE_NEW_CUSTOM_LIST_BUTTON = appConstants_1.codingListConstants.codingListCreateNewCustomListButton;
const CODING_LIST_CREATE_NEW_CUSTOM_LIST_CANCEL_BUTTON = appConstants_1.codingListConstants.codingListCreateNewCustomListCancelButton;
const CUSTOM_CODING_LIST_TEMPLATE = ({ codingListName, codingListId }) => appConstants_1.codingListConstants.customCodingListTemplate({ codingListName, codingListId });
const CreateCustomCodingListAside = () => {
    const [newCustomCodingValue, setNewCustomCodingValue] = (0, react_1.useState)('');
    const state = (0, useCodingListState_1.useCodingPageState)();
    const { setPageLoading } = (0, zustandStore_1.useZustand)();
    const disableCodingListQuery = (0, codingQuery_1.useDisableCodingListQuery)();
    const updateCodingListQuery = (0, codingQuery_1.useUpdateCodingListQuery)();
    function onNewCustomCodingListChange(value) {
        setNewCustomCodingValue(value);
    }
    const onCreateNewCustomCodingListButtonClick = () => {
        if (!newCustomCodingValue || !newCustomCodingValue.trim()) {
            return;
        }
        setPageLoading(true);
        const id = (0, uuid_1.v4)();
        const codingList = CUSTOM_CODING_LIST_TEMPLATE({
            codingListName: newCustomCodingValue,
            codingListId: id,
        });
        state.setIsCustomCodingListAsideOpen(false);
        state.setIsCreateCodinglistAsideOpen(false);
        setNewCustomCodingValue('');
        updateCodingListQuery.mutate({ codingList }, {
            onSuccess: () => {
                state.setCurrentCodingListSelected({ ...codingList, enabled: false });
                disableCodingListQuery.mutate({ codingListCode: codingList.id });
            },
            onSettled: () => {
                setPageLoading(false);
            },
        });
    };
    const footerButtons = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "createNewCodingList-btn", label: strings_1.companySettingsCodingStrings.CREATE_NEW_CUSTOM_LIST_BUTTON, onClick: () => onCreateNewCustomCodingListButtonClick() }, CODING_LIST_CREATE_NEW_CUSTOM_LIST_BUTTON), (0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "cancel-btn", label: strings_1.companySettingsCodingStrings.CREATE_NEW_CUSTOM_LIST_CANCEL_BUTTON, color: uiConstants_1.UI_BUTTON_SECONDARY, onClick: () => state.setIsCustomCodingListAsideOpen(false) }, CODING_LIST_CREATE_NEW_CUSTOM_LIST_CANCEL_BUTTON)] }));
    return ((0, jsx_runtime_1.jsx)(drawerAside_1.default, { id: CODING_LIST_CREATE_NEW_CUSTOM_LIST_ASIDE_ID, title: strings_1.companySettingsCodingStrings.CREATE_NEW_CUSTOM_LIST_ASIDE_TITLE, open: state.isCustomCodingListAsideOpen, onClose: () => state.setIsCustomCodingListAsideOpen(false), footerButtons: footerButtons, children: (0, jsx_runtime_1.jsx)(material_1.FormGroup, { style: { margin: 1, justifyContent: 'space-between', flex: 1 }, children: (0, jsx_runtime_1.jsxs)(material_1.FormControl, { sx: { mb: 'auto', p: 0 }, children: [(0, jsx_runtime_1.jsx)(FormLabel_1.StyledFormLabel, { children: strings_1.companySettingsCodingStrings.CREATE_NEW_CUSTOM_LIST_INPUT_LABEL }), (0, jsx_runtime_1.jsx)(material_1.OutlinedInput, { id: CODING_LIST_CREATE_NEW_CUSTOM_LIST_INPUT, name: CODING_LIST_CREATE_NEW_CUSTOM_LIST_INPUT, type: 'text', value: newCustomCodingValue, onChange: event => onNewCustomCodingListChange(event.target.value) })] }, CODING_LIST_CREATE_NEW_CUSTOM_LIST_INPUT) }) }));
};
exports.default = CreateCustomCodingListAside;
